import { Box, Grid } from '@mui/material';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import LeadGenerationContext from '../../../context/LeadGenerationContext';
import { FundingScreenStyles as classes } from './FundingScreenStyles';
import { CustomInput } from '../CustomInput/CustomInput';
import ExpiryDate from './ExpiryDate';
import { INVALID_FORMAT_ERR, MIN_DEPOSIT_ERR, REQUIRED, DEPOSIT_AMOUNT } from '../../../constants';
import { commonUtilityValueReturn } from '../UtilityFunctions';

const DebitCard = () => {
  const { t } = useTranslation();
  const leadGenerationContext = useContext(LeadGenerationContext);
  const { fundData, fundDataErrors, setFundData, setFundDataErrors, setIsFundingScreenDirty } =
    leadGenerationContext;
  const depositeAmountChange = (e) => {
    if (e.target?.value?.match(/^\d*$/)) {
      setFundData({ ...fundData, [e.target.name]: e.target.value });
      if (parseInt(e.target.value, 10) >= parseInt(fundData?.minDepositAmount, 10)) {
        setFundDataErrors({ ...fundDataErrors, [e.target.name]: e.target.value });
      } else {
        setFundDataErrors({
          ...fundDataErrors,
          [e.target.name]: MIN_DEPOSIT_ERR,
        });
      }
    } else if (e.target.value === '') {
      setFundData({ ...fundData, [e.target.name]: e.target.value });
      setFundDataErrors({
        ...fundDataErrors,
        [e.target.name]: '',
      });
      // setFundDataErrors((prevState) => Object.assign({}, prevState, { [e.target.name]: "* Mandatory Field" }))
    }
  };
  const handleChange = (e) => {
    setIsFundingScreenDirty(true);
    switch (e.target.name) {
      case 'depositAmount':
        depositeAmountChange(e);
        break;

      case 'cardNumber':
        if (e.target?.value?.match(/^\d*$/)) {
          if (e.target.value.length < 16) {
            setFundData({ ...fundData, [e.target.name]: e.target.value });
            setFundDataErrors({
              ...fundDataErrors,
              [e.target.name]: INVALID_FORMAT_ERR,
            });
          } else {
            setFundData({ ...fundData, [e.target.name]: e.target.value });
            setFundDataErrors({
              ...fundDataErrors,
              [e.target.name]: '',
            });
          }
        } else if (e.target.value === '') {
          setFundData({ ...fundData, [e.target.name]: e.target.value });
          setFundDataErrors({
            ...fundDataErrors,
            [e.target.name]: '',
          });
          // setFundDataErrors((prevState) => Object.assign({}, prevState, { [e.target.name]: "* Mandatory Field" }))
        }
        break;

      default:
        break;
    }
  };

  return (
    <>
      <Grid
        container
        size={{ md: 6 }}
        sx={[
          classes.inputs_grid_margin,
          classes.margin_adjust_for_top_grid,
          classes.field_padding_right,
        ]}
      >
        <Grid size={{ xs: 12 }}>
          <CustomInput
            id="depositAmount"
            dataTestId="depositAmount_id"
            autoFocus
            required={false}
            inputLabelAriaLabel={`${t(DEPOSIT_AMOUNT, {
              defaultValue: DEPOSIT_AMOUNT,
            })} ${t(REQUIRED, { defaultValue: REQUIRED })}`}
            label={t(DEPOSIT_AMOUNT, { defaultValue: DEPOSIT_AMOUNT })}
            handleChange={handleChange}
            placeholder={t('Enter deposit amount', {
              defaultValue: 'Enter deposit amount',
            })}
            fullWidth
            inputProps={{
              'data-testid': 'deposit-amount',
              inputMode: 'numeric',
            }}
            value={commonUtilityValueReturn(fundData?.depositAmount, fundData?.depositAmount, '')}
            error={fundDataErrors?.depositAmount ? fundDataErrors.depositAmount : ''}
          />
          <Box
            component="span"
            sx={classes.error_message}
            role="alert"
            data-testid="deposit-amount-error"
          >
            {fundDataErrors?.depositAmount === MIN_DEPOSIT_ERR && fundData?.minDepositAmount
              ? `${t(fundDataErrors?.depositAmount, {
                  defaultValue: fundDataErrors?.depositAmount,
                })}${fundData?.minDepositAmount}`
              : t(fundDataErrors?.depositAmount, {
                  defaultValue: fundDataErrors?.depositAmount,
                })}
          </Box>
        </Grid>
      </Grid>

      <Grid
        container
        size={{ md: 6 }}
        sx={[
          classes.inputs_grid_margin,
          classes.margin_adjust_for_top_grid,
          classes.field_padding_left,
        ]}
      >
        <Grid size={{ xs: 12 }}>
          <CustomInput
            id="cardNumber"
            dataTestId="cardNumber_id"
            required={false}
            inputLabelAriaLabel={`${t('Card Number', {
              defaultValue: 'Card Number',
            })} ${t(REQUIRED, { defaultValue: REQUIRED })}`}
            label={t('Card Number', { defaultValue: 'Card Number' })}
            handleChange={handleChange}
            placeholder={t('Enter card number', {
              defaultValue: 'Enter card number',
            })}
            fullWidth
            inputProps={{
              maxLength: 16,
              'data-testid': 'card-number',
              inputMode: 'numeric',
            }}
            value={fundData?.cardNumber ? fundData.cardNumber : ''}
            error={fundDataErrors?.cardNumber ? fundDataErrors.cardNumber : ''}
          />
          <Box
            component="span"
            sx={classes.error_message}
            role="alert"
            data-testid="card-number-error"
          >
            {t(fundDataErrors?.cardNumber, {
              defaultValue: fundDataErrors?.cardNumber,
            })}
          </Box>
        </Grid>
      </Grid>

      <Grid
        container
        size={{ md: 6 }}
        sx={[classes.inputs_grid_margin, classes.field_padding_right]}
      >
        <Grid size={{ xs: 12 }}>
          <ExpiryDate />
          <Box
            component="span"
            sx={classes.error_message}
            role="alert"
            data-testid="expiry-date-error"
          >
            {t(fundDataErrors?.expiryDate, {
              defaultValue: fundDataErrors?.expiryDate,
            })}
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default DebitCard;
